// extracted by mini-css-extract-plugin
export default {"mainContainer":"StopInterviews_mainContainer__uFTEe"};